import { ArrowRightOutlined } from '@ant-design/icons'
import React, {useState} from 'react'
import { Link, withRouter } from 'react-router-dom'

const numberFormat = (value) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0, 
        minimumFractionDigits: 0, 
    }).format(value);
}

function Personalised({data, history}) {
    const [click, setClick] = useState(false);
    const handleRoute = (id) => {
        if (!click) {
         
          history.push(`/desc/${id}`);
        }
      };

    return (
        <div className='wrapPopularDestinations'>
            
            <div className='titleMobileWrap'>
                <div className='captionWrap'>
                    Personalised for you
                </div>
                {/* <div className='actionBar'>
                    <Link to={`/search`}>
                        <button>
                            <ArrowRightOutlined />
                        </button>
                    </Link>
               
            </div> */}
            </div>
            <div className='selectionContent'>
                <div className='emptyBox'></div>
                {data !== null && (
                    data.section_5.experiences.map((item, idx) => (
                        <Link key={idx} to={`/personalised/${item.title}`}>
                        <div className='contentContainer'>
                            <div className='imageBox'>
                                <img src={item.img} />
                                <div className='placeName'>{item.title}</div>
                            </div>
                            
                        </div>
                        </Link>
                    ))

                )}
                <div className='emptyBox'></div>
            </div>
        </div>
    )
}

export default withRouter(Personalised)